import React, { useState, useEffect } from "react";
import Picture from "../images/image.png";
// import Character from "./Character";
import { Link } from "react-router-dom";
import { personalInfo } from "../config/personalInfo";

export default function Home() {
  const [isImageHovered, setIsImageHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative min-h-screen flex items-center py-12 sm:py-0">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-white to-blue-50 opacity-50" />
        <div
          className="absolute inset-0 transition-opacity duration-500"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, #e5e7eb 1px, transparent 0)",
            backgroundSize: "40px 40px",
            opacity: isImageHovered ? "0.3" : "1",
          }}
        />

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              {/* Text Content */}
              <div className="order-2 lg:order-1 text-center lg:text-left">
                <div
                  className={`space-y-6 opacity-0 transition-all duration-1000 ease-out transform translate-y-8 ${
                    isVisible ? "opacity-100 translate-y-0" : ""
                  }`}
                >
                  <div>
                    <h2 className="text-sm uppercase tracking-widest text-blue-600 font-medium">
                      {personalInfo.title}
                    </h2>
                    <div className="flex items-start justify-center lg:justify-start gap-3 mt-2">
                      <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-tight">
                        Hi, I'm {personalInfo.name}
                      </h1>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                      {personalInfo.tagline}. {personalInfo.description}
                    </p>

                    <p className="text-sm sm:text-base lg:text-lg text-gray-500 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                      {personalInfo.currentWork.description}
                    </p>
                  </div>

                  <div className="flex flex-wrap justify-center lg:justify-start gap-4">
                    <Link
                      to="/projects"
                      className="group inline-flex items-center px-6 py-3 text-sm font-medium text-white bg-gray-900 rounded-lg transition-all duration-300 hover:bg-gray-800 hover:scale-105 hover:shadow-lg"
                    >
                      <span className="relative">View Projects</span>
                      <svg
                        className="w-4 h-4 ml-2 -mr-1 transition-transform duration-300 group-hover:translate-x-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 8l4 4m0 0l-4 4m4-4H3"
                        />
                      </svg>
                    </Link>
                    <Link
                      to="/contact"
                      className="group inline-flex items-center px-6 py-3 text-sm font-medium text-gray-900 bg-gray-100 rounded-lg transition-all duration-300 hover:bg-gray-200 hover:scale-105 hover:shadow-lg"
                    >
                      <span>Let's Talk</span>
                      <svg
                        className="w-4 h-4 ml-2 -mr-1 transition-transform duration-300 group-hover:rotate-12"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                        />
                      </svg>
                    </Link>
                  </div>

                  <div className="grid grid-cols-3 gap-4 sm:gap-6 pt-4">
                    {personalInfo.stats.map((stat, index) => (
                      <div
                        key={index}
                        className="group space-y-2 transition-transform duration-300 hover:scale-105"
                      >
                        <p className="text-3xl font-bold text-gray-900 transition-colors duration-300 group-hover:text-blue-600">
                          {stat.number}
                        </p>
                        <p className="text-sm text-gray-500">{stat.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Image Section */}
              <div
                className={`order-1 lg:order-2 flex justify-center lg:justify-end relative opacity-0 transition-all duration-1000 ease-out transform translate-y-8 ${
                  isVisible ? "opacity-100 translate-y-0" : ""
                }`}
              >
                {/* Background blur effect */}
                <div
                  className="absolute -inset-4 bg-gradient-to-br from-blue-100/30 via-white/10 to-gray-100/30 blur-3xl rounded-full transition-opacity duration-500"
                  style={{ opacity: isImageHovered ? "0.8" : "0.3" }}
                />

                <div
                  className="relative"
                  onMouseEnter={() => setIsImageHovered(true)}
                  onMouseLeave={() => setIsImageHovered(false)}
                >
                  {/* Main image container */}
                  <div className="w-80 h-80 sm:w-96 sm:h-96 rounded-3xl overflow-hidden bg-gradient-to-br from-blue-50 via-white to-gray-50 p-1 shadow-xl transition-all duration-500 hover:shadow-2xl">
                    <div className="w-full h-full rounded-2xl overflow-hidden bg-gradient-to-br from-gray-100 to-white p-0.5">
                      <img
                        src={Picture}
                        alt={`${personalInfo.name}'s Profile`}
                        className="w-full h-full object-cover rounded-2xl transition-all duration-700 hover:scale-110"
                        style={{ objectPosition: "95% 50%" }}
                      />
                    </div>
                  </div>

                  {/* Decorative elements */}
                  <div className="absolute -z-10 -top-6 -right-6 w-80 h-80 sm:w-96 sm:h-96 border-2 border-gray-900/10 rounded-3xl transition-transform duration-500 hover:scale-105" />
                  <div className="absolute -z-10 -bottom-6 -left-6 w-80 h-80 sm:w-96 sm:h-96 border-2 border-blue-500/20 rounded-3xl transition-transform duration-500 hover:scale-105" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
